// 校验是否含有特殊字符
export function checkChart(string: any, all = false) {
  let regEn
  if (all) {
    regEn = /[`~!#$%^&*()_+.<>?:@"{},\/;'[\]]/im
  } else {
    regEn = /[`~!#$%^&*()_+<>?.:"{},\/;'[\]]/im
  }
  const regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im
  const iconRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g
  return regEn.test(string) || regCn.test(string) || iconRule.test(string)
}

// 验证固话或者手机
export function checkTel(tel: any) {
  let isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/
  const isMob = /^1(3|4|5|6|7|8|9)\d{9}$/
  return isMob.test(tel) || isPhone.test(tel)
}

// email校验
export function validEmail(email: any) {
  const szReg = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/
  return szReg.test(email)
}

// 验证银行卡号
export function checkAccount(data: any) {
  const regExp = /^([1-9]{1})(\d{15}|\d{18})$/
  return regExp.test(data)
}

// 税号校验
export function checkTaxId(Code: any) {
  const patrn = /^[0-9A-Z]+$/
  // 18位校验及大写校验
  if ((Code.length !== 18) || !patrn.test(Code)) {
    return false
  } else {
    let Anode: any = undefined // 统一社会信用代码的每一个值
    let Ancodevalue: any = undefined  // 统一社会信用代码每一个值的权重
    let total = 0
    let weightedfactors: any = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28] // 加权因子
    let str = '0123456789ABCDEFGHJKLMNPQRTUWXY'
    // 不用I、O、S、V、Z
    for (let i = 0; i < Code.length - 1; i++) {
      Anode = Code.substring(i, i + 1)
      Ancodevalue = str.indexOf(Anode)
      total = total + Ancodevalue * weightedfactors[i]
      // 权重与加权因子相乘之和
    }
    let logiccheckcode: any = 31 - total % 31
    // @ts-ignore
    if (logiccheckcode === 31) {
      logiccheckcode = 0
    }
    let Str = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y'
    let Array_Str = Str.split(',')
    logiccheckcode = Array_Str[logiccheckcode]
    let checkcode: any = Code.substring(17, 18)
    return logiccheckcode === checkcode
  }
}

